import 'angular:locale/data:es-ES';
import 'zone.js';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "es-ES";
